import React from 'react'
import { useDispatch } from 'react-redux'
import { resetActions } from 'state/modules/locations'
import { AppContainer } from '~/views/shared'
import { LocationIndexPage } from './LocationIndexPage'
import { LocationCreatePage } from './LocationCreatePage'
import { LocationUpdatePage } from './LocationUpdatePage'
import { LayoutIndexPage } from './LayoutIndexPage'
import { SectorIndexPage } from './LayoutIndexPage/SectorIndexPage'
import { LayoutCreatePage } from './LayoutIndexPage/LayoutCreatePage'
import { LayoutUpdatePage } from './LayoutIndexPage/LayoutUpdatePage'
import { SectorCreatePage } from './LayoutIndexPage/SectorIndexPage/SectorCreatePage'
import { SectorUpdatePage } from './LayoutIndexPage/SectorIndexPage/SectorUpdatePage'
import { SectorClonePage } from './LayoutIndexPage/SectorIndexPage/SectorClonePage'
import { SeatsCreatePage } from './LayoutIndexPage/SectorIndexPage/SeatsCreatePage'
import { Route, Switch } from 'react-router-dom'
import { ROUTES } from '~/views/routes'
import history from '~/config/history'

export const LocationsPage = () => {
  const dispatch = useDispatch()

  const handleSuccessfulSubmit = async () => {
    await dispatch(resetActions())
    history.push(ROUTES.ADMIN.LOCATIONS.INDEX)
  }

  const handleSuccessPlanimetry = async (locationId) => {
    await dispatch(resetActions())
    history.push(
      ROUTES.ADMIN.LOCATIONS.PLANIMETRY.INDEX.replace(':locationId', locationId)
    )
  }

  const handleSuccessSector = async (locationId, layoutId) => {
    await dispatch(resetActions())
    history.push(
      ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.INDEX.replace(
        ':locationId',
        locationId
      ).replace(':layoutId', layoutId)
    )
  }

  return (
    <AppContainer title='Lugares'>
      <Switch>
        <Route
          path={ROUTES.ADMIN.LOCATIONS.INDEX}
          component={LocationIndexPage}
          exact
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.CREATE}
          render={(props) => (
            <LocationCreatePage {...props} onSuccess={handleSuccessfulSubmit} />
          )}
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.UPDATE}
          render={(props) => (
            <LocationUpdatePage {...props} onSuccess={handleSuccessfulSubmit} />
          )}
        />
        <Route
          exact
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.INDEX}
          render={(props) => <LayoutIndexPage {...props} />}
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.CREATE}
          render={(props) => (
            <LayoutCreatePage {...props} onSuccess={handleSuccessPlanimetry} />
          )}
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.UPDATE}
          render={(props) => (
            <LayoutUpdatePage {...props} onSuccess={handleSuccessPlanimetry} />
          )}
        />
        <Route
          exact
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.INDEX}
          render={(props) => <SectorIndexPage {...props} />}
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.CREATE}
          render={(props) => (
            <SectorCreatePage {...props} onSuccess={handleSuccessSector} />
          )}
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.CLONE}
          render={(props) => (
            <SectorClonePage {...props} onSuccess={handleSuccessSector} />
          )}
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.UPDATE}
          render={(props) => (
            <SectorUpdatePage {...props} onSuccess={handleSuccessSector} />
          )}
        />
        <Route
          path={ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.SEATS}
          render={(props) => (
            <SeatsCreatePage {...props} onSuccess={handleSuccessSector} />
          )}
        />
      </Switch>
    </AppContainer>
  )
}

export default LocationsPage
